import useEmblaCarousel from "embla-carousel-react";
import Image from "next/image";
import Link from "next/link";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { useRef } from "react";


const ServicesRest = ({ items, title, text, btn_text}) => {


  const [emblaRef] = useEmblaCarousel({ align: "start" });

    const itemsRefs = useRef([]);
    const sectionRef = useRef(null);
    const titleRef = useRef(null);
    const textRef = useRef(null);
    const containerRef = useRef(null)
  
    useGSAP(() => {
      const mm = gsap.matchMedia();
  
      mm.add("(min-width: 1280px)", () => {

        
          gsap.fromTo(containerRef.current, {
            y: '10rem'
          },
              {
            y: 0,
            ease: "none",
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top bottom", 
              end: "top 55%",  
              scrub: 0.1,  
            },
          });
  
        if (titleRef.current) {
          gsap.fromTo(titleRef.current, { opacity: 0 }, {
            opacity: 1,
            duration: 1,
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top 70%",
            },
          });
        }
  
        if (textRef.current) {
          gsap.fromTo(textRef.current, { opacity: 0 }, {
            opacity: 1,
            duration: 1,
            delay: 0.2,
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top 50%",
            },
          });
        }
  
        const offsets = [20, 10, 15, 15];
  
        itemsRefs.current.forEach((item, index) => {
          const initialY = offsets[index] !== undefined ? offsets[index] : 0;
  
          gsap.fromTo(item, {
            y: `${initialY}rem`,
  
          }, {
            y: 0,
            duration: 1,
            delay: index * 0.1,
            scrollTrigger: {
              trigger: item.parentElement,
              start: "top 100%",
              end: "top 40%",
              // markers: true,
              scrub: 0.5
            },
          });
  
  
          const imageElement = item.querySelector('img');
          if (imageElement) {
            gsap.fromTo(imageElement, {
              y: '-4rem',
            }, {
              y: '4rem',
              ease: "none",
              scrollTrigger: {
                trigger: item.parentElement,  
                start: "top bottom",
                end: "bottom start",
                scrub: 0,
              },
            });
          }
  
        });
  
  
      });
  
      return () => mm.revert();
  }, {scope: sectionRef, dependencies: items});

  return (
    <section ref={sectionRef} className="flex container-max overflow-hidden flex-col w-full py-[4rem] md:py-[6rem] lg:py-[8rem] xl:py-[10rem] ">
      <div className="" ref={containerRef}>

        <div className="mb-[2.4rem] md:mb-[4rem] xl:mb-[5.2rem] text-left container-padding flex-col container-grid">
          <h2 ref={titleRef} className="w-full lg:text-left md:mb-0  md:col-span-2 mb-[2rem]   lg:col-start-0 lg:col-span-5">
            {title}
          </h2>
          <p className=" lg:items-center text-1 lg:hidden md:col-span-2 md:col-start-4 lg:col-span-3 lg:col-start-8">
            {text}
          </p>
        </div>

        <div className="hidden lg:block  h-[1px] w-full mb-[2.4rem] lg:mb-[3.2rem] bg-dusty-blue-20"></div>

        {/* Mobile carousel */}
        <div
          className="embla lg:hidden mb-[2.4rem] md:mb-[4rem] px-[2rem] md:px-[2.4rem]"
          ref={emblaRef}
        >
          <div className="embla__container gap-[1.2rem] md:gap-[1.6rem]">
            {items?.map((item, index) => (
              <div
                key={index}
                className="embla__slide flex flex-col w-[calc(100%-4rem)] md:flex-row items-stretch flex-[0_0_31.6rem] md:flex-[0_0_59.6rem]"
              >
                <div className="relative md:shrink-0 aspect-[1.44/1] md:aspect-[0.76] md:w-1/2  w-full">
                  <Image
                    src={item?.image?.url}
                    alt={item?.image?.alt}
                    fill
                    sizes="300px"
                    className="w-auto object-cover"
                  />
                </div>
                <div className="flex-1 flex flex-col items-start justify-between md:flex-initial bg-dusty-pink-light p-[2rem]">
                  <div>
                    <h3 className="mb-[1.6rem] heading-4">{item.name ?? item.title}</h3>
                    {item.short_description ? <div className="w-full flex flex-col gap-[1.6rem] md:mb-[15.2rem] mb-[4.8rem]">
                      {item.short_description.map((t, textIndex) => (
                        <p key={`${index}-text-${textIndex}`} className="text-1">
                          {t.text}
                        </p>
                      ))}
                    </div> : null}

                  </div>

                  <Link href={item.link ?? "/uslugi"} className=" text-link">
                    {btn_text}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Desktop cards */}
        <div className="hidden lg:flex container-padding mb-[4rem]">
          <div className="flex w-full  gap-[8.3%]">
            <p ref={textRef} className="text-1 flex-1">{text}</p>
            {items?.map((item, index) => (
              <div ref={el => {
                if (el) {
                  itemsRefs.current[index] = el;
                }
              }}  key={index} className="relative flex-1 card group w-full flex flex-col">
                <Link href={item.link ?? "/uslugi"} aria-label="Перейти к услуге" className="w-full mb-[1.2rem] overflow-hidden relative">
                  <div className="relative overflow-hidden flex items-center justify-center aspect-[0.71/1] w-full">
                    <div className='overflow-hidden flex items-center justify-center w-full h-[calc(100%-2px)]'>
                      <div className='relative w-full h-[130%]'>
                        <Image
                          src={item?.image?.url}
                          alt={item?.image?.alt} 
                          fill
                          sizes="400px"
                          className="w-auto object-cover"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="bg-dusty-pink-light card-polygon-overlay scale-[1.01] absolute inset-0"></div>
                  <div className='bg-dusty-pink-light group-hover:opacity-100 opacity-0 transition-opacity duration-500 absolute inset-0 '></div>

                  <div className="z-10 absolute group-hover:opacity-100 opacity-0 transition-opacity duration-500 inset-0 flex w-full items-start flex-col justify-between p-[2rem] lg:py-[3.2rem]">
                    <p className=" text-link mb-auto">
                      {btn_text}
                    </p>
                    <div>
                      {item.short_description ?                       <div className="  w-full flex flex-col gap-[1.6rem]">
                        {item.short_description.map((t, textIndex) => (
                          <p key={`${index}-overlay-text-${textIndex} `} className="text-1 line-clamp-6 xl:line-clamp-none">
                            {t.text}
                          </p>
                        ))}
                      </div> : null} 

                    </div>
                  </div>
                </Link>
                <h3 className="mb-[1.6rem] heading-4">{item.title}</h3>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ServicesRest;
